import React, {useState, useEffect, useCallback} from 'react';
import ConcertsPageStyles from './ConcertsPage.module.scss';
import {useAppDispatch, useAppSelector} from "../../utils";
import {fetchEvents} from "../../services/slices/EventSlice";
import {EventType} from "../../entity/index.entity";
import {API_URL_PHOTO} from "../../constants";

const icons = [
    {src: './yand.svg', name: 'yandex'},
    {src: './apl.svg', name: 'apple'},
    {src: './sptfy.svg', name: 'spotify'},
    {src: './vkMus.svg', name: 'vkMusic'},
]

const EventCard = ({city, image, date, time, place, tickets_url}: EventType) => (
    <div className={ConcertsPageStyles.concerts}>
        <div className={ConcertsPageStyles.border}>
            {tickets_url && (
                <a href={tickets_url} target="_blank" rel="noopener noreferrer">
                    <img
                        className={ConcertsPageStyles.concertsPhoto}
                        src={API_URL_PHOTO + image}
                        alt={image}
                    />
                </a>
            )}
            {!tickets_url && (
                <img
                    className={ConcertsPageStyles.concertsPhoto}
                    src={API_URL_PHOTO + image}
                    alt={image}
                />
            )}
            <p className={ConcertsPageStyles.name}>{city}</p>
            <div className={ConcertsPageStyles.dateTime}>
                <p style={{marginRight: '5px'}}>{date}</p> <p>{time}</p>
            </div>

            <p className={ConcertsPageStyles.role}>{place}</p>
        </div>
    </div>
);

const IconCard = ({src, name}: { src: string, name: string }) => (
    <div>
        <img src={src} alt={name} className={ConcertsPageStyles.icon}/>
    </div>
);

const ConcertsPage = () => {
    const dispatch = useAppDispatch()
    const images = useAppSelector((state) => state.eventSlice.images);
    const events = useAppSelector((state) => state.eventSlice.events);

    useEffect(() => {
        dispatch(fetchEvents());
    }, [dispatch]);

    const [activeIndex, setActiveIndex] = useState(0);

    const nextSlide = useCallback(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, [images.length]);

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [nextSlide]);

    return (
        <div>
            <div className={ConcertsPageStyles.wrapper}>
                <div className={ConcertsPageStyles.slider}>
                    <div
                        className={ConcertsPageStyles.sliderContent}
                        style={{
                            transform: `translateX(-${activeIndex * 100}%)`,
                            transition: 'transform 0.5s ease-in-out',
                        }}
                    >
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className={ConcertsPageStyles.slide}
                            >
                                <img
                                    src={API_URL_PHOTO + image}
                                    alt={`Slide ${index}`}
                                    className={ConcertsPageStyles.sliderImage}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className={ConcertsPageStyles.concertsWrapper}>
                    <div className={ConcertsPageStyles.row}>
                        {events.length !== 0 ? events.map((event, index) => (
                            <EventCard key={index} {...event} />
                        )) : (
                            <h2>Событий пока нет... </h2>
                        )}
                    </div>
                </div>

                <div className={ConcertsPageStyles.footer}>
                    <div className={ConcertsPageStyles.iconsList}>
                        {icons.map((icon, index) => (
                            <IconCard key={index} {...icon} />
                        ))}
                    </div>

                    <div className={ConcertsPageStyles.description}>
                        <p className={ConcertsPageStyles.descriptionItem}>По поводу сотрудничества писать на почту</p>
                        <p className={ConcertsPageStyles.descriptionItem}>epatazhnost@yandex.ru</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConcertsPage;